// @flow

import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import BackButton from 'app/components/commons/BackButton';
import FriendOpenCard from 'app/components/friends/friendCard/FriendOpenCard';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import Responsive from 'app/components/responsive/Responsive';

type Props = {
  classes: Object,
  friend?: iFriendUser,
  onBack?: () => void,
  // dodgy override prop
  showOnMobile?: boolean,
};

class FriendSlider extends React.Component {
  props: Props;

  static defaultProps = {
    friend: undefined,
    onBack: undefined,
    showOnMobile: false,
  };

  render() {
    const { classes, onBack, friend, showOnMobile } = this.props;

    return (
      <Responsive mobile>
        {isMobile => (
          <AnimatedGroup
            onAppear={Enter.slideLeftAndAppear(0.5, 0.5)}
            onEnter={Enter.slideLeftAndAppear(0.5, 0.5)}
            onLeave={Leave.slideRightAndDisappear(0.5)}
          >
            {friend &&
              (!isMobile || showOnMobile) && (
                <div
                  className={classNames(classes.openFriend, {
                    desktop: !isMobile,
                    mobile: isMobile,
                  })}
                >
                  <BackButton scheme="dark" onClick={onBack} className={classes.back} />
                  <FriendOpenCard friend={friend} />
                </div>
              )}
          </AnimatedGroup>
        )}
      </Responsive>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    back: {
      fontSize: 20,
      position: 'absolute',
      zIndex: theme.zIndex.fullscreen,
    },
    openFriend: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: theme.zIndex.fullscreen,
      '&.mobile': {
        position: 'fixed',
      },
      '&.desktop': {
        position: 'absolute',
      },
    },
  };
}

export default useSheet(applyStyles)(FriendSlider);
